// src/utils/getProfileLink.js

/**
 * Genera la URL correcta para el perfil de un usuario basándose en su rol.
 * @param {object} user - El objeto del usuario, debe contener 'role' y 'username'.
 * @returns {string} La ruta del perfil.
 */
export const getProfileLink = (user) => {
  if (!user) return '/';

  const hasBloggerRole = false;
  const hasActiveTools = user.creatorToolsActive === undefined ? hasBloggerRole : user.creatorToolsActive;

  if (hasBloggerRole && hasActiveTools) {
    return `/blogger/${user.username}`;
  }
  // Para 'user', 'admin' y cualquier otro rol, se usa el perfil social estándar.
  return `/profile/${user.username}`;
};
